
import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";

export const getUserProfile = async () => {
  return commonFetch(API_URLS.GET_USER_PROFILE_APIURL, {
    method: "GET",
    requiresAuth: true,
  });
};

export const AddStudent = async () => {
  return commonFetch(API_URLS.ADD_STUDENT_APIURL, {
    method: "GET",
    requiresAuth: true,
  });
};

export const checkSessionAPI = async () => {
  return commonFetch(API_URLS.ADMIN_AREA_APIURL, {
    method: "GET",
    requiresAuth: true
  });
};

export const refreshTokenAPI = async (refPayload) => {
  return commonFetch(API_URLS.REFRESH_COMMON_TOKEN_API, {
    method: "POST",
    body: refPayload,
    requiresAuth: true
  });
};

export const getAllSchoolMappedClases = async (payload) => {
  return commonFetch(API_URLS.GET_ALL_SCHOOL_MAPPED_CLASSES, {
    method: "POST",
    body: payload,
    requiresAuth: true
  });
};

export const getAllStreamMasterTable = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ALL_STREAM_MASTERTABLE}/${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};
export const getAllSubStreamsMasterTable = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ALL_SUB_STREAM_MASTERTABLE}/${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};
export const getAllSubjectsMasterTable = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ALL_SUBJECT_MASTERTABLE}/${schoolID}`, {
    method: "GET",
    requiresAuth: true,
  });
};
export const getAllClassMasterTable = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ALL_CLASS_MASTERTABLE}/${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};
export const getAllClassSectionMasterTable = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ALL_CLASS_SECTION_MASTERTABLE}/${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};
export const updateStreamMasterTable = async (payload) => {
  return commonFetch(API_URLS.UPDATE_STREAM_MASTERTABLE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const addStreamMasterTable = async (payload) => {
  return commonFetch(API_URLS.ADD_STREAM_MASTERTABLE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};
export const updateSubStreamMasterTable = async (payload) => {
  return commonFetch(API_URLS.UPDATE_SUB_STREAM_MASTERTABLE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const addSubStreamMasterTable = async (payload) => {
  return commonFetch(API_URLS.ADD_SUB_STREAM_MASTERTABLE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};
export const updateSubjectMasterTable = async (payload) => {
  return commonFetch(API_URLS.UPDATE_SUBJECT_MASTERTABLE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const addSubjectMasterTable = async (payload) => {
  return commonFetch(API_URLS.ADD_SUBJECT_MASTERTABLE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};
export const updateClassMasterTable = async (payload) => {
  return commonFetch(API_URLS.UPDATE_CLASS_MASTERTABLE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const addClassMasterTable = async (payload) => {
  return commonFetch(API_URLS.ADD_CLASS_MASTERTABLE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};
export const updateSectionMasterTable = async (payload) => {
  return commonFetch(API_URLS.UPDATE_SECTION_MASTERTABLE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const addSectionMasterTable = async (payload) => {
  return commonFetch(API_URLS.ADD_SECTION_MASTERTABLE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};

export const deleteSectionById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_SECTION_MASTERTABLE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};
export const deleteClassById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_Class_MASTERTABLE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};
export const deleteStreamById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_STREAM_MASTERTABLE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};
export const deleteSubStreamById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_SUBSTREAM_MASTERTABLE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};
export const deleteSubjectById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_SUBJECT_MASTERTABLE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};

export const getAllPeriodTable = async (schoolID) => {
  return commonFetch(`${API_URLS.GETALL_PERIOD_APIURL}/${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const addPeriodTable = async (payload) => {
  return commonFetch(API_URLS.CREATE_PERIOD_APIURL, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};


export const updatePeriodTable = async (payload) => {

  const formData = new FormData();

  Object.keys(payload).forEach(key => {
    formData.append(key, payload[key]);
  });

  return commonFetch(API_URLS.UPDATEPERIOD_APIURL, {
    method: 'PUT',
    headers: {
    },
    body: formData,
    requiresAuth: true,
  });
};


export const deletePeriodById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_PERIOD_TABLE}`, {
    method: 'DELETE',
    headers: {

    },
    body: formData,
    requiresAuth: true,
  });
};

// export const addStudentAttendenceMark = async (payload) => {
//   return commonFetch(API_URLS.ADD_STUDENTATTENDENCEMARK_APIURL, {
//     method: 'POST',
//     body: payload,
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     requiresAuth: true,
//   });
// };
export const addStudentAttendenceMark = async (payload) => {
  return commonFetch(API_URLS.ADD_STUDENTATTENDENCEMARK_APIURL, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};

export const UpdateStudentAttendenceMark = async (formData) => {
  return commonFetch(API_URLS.UPDATE_STUDENTATTENDENCEMARK_APIURL, {
    method: 'PUT',
    body: formData,

    requiresAuth: true,
  });
};

export const getAllStudentAttendenceMark = async (SchoolID) => {
  return commonFetch(
   `${API_URLS.GETALL_STUDENTATTENDENCEMARK_APIURL}/${SchoolID}`,
    {
      method: "GET",
      requiresAuth: true
    });
};



export const classTeacherList = async (payload) => {

  const formData = new FormData();

  Object.keys(payload).forEach(key => {
    formData.append(key, payload[key]);
  });

  return commonFetch(API_URLS.UPDATEPERIOD_APIURL, {
    method: 'PUT',
    headers: {
    },
    body: formData,
    requiresAuth: true,
  });
};



// export const UpdateClassTeacher = async (payload) => {
//   return commonFetch(API_URLS.ADD_CLASSTEACHER_ASSINED_CLASS_SECTION_APIURL, {
//     method: 'POST',
//     body: payload,
//     headers: {

//     },
//     requiresAuth: true,
//   });
// };

export const getAllTeacher = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ALL_TEACHER_APIURL}/${schoolID}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getAllClasses = async (schoolID) => {
  return commonFetch(`${API_URLS.GETALL_CLASS_MAPPING_APIURL}/${schoolID}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getAllClassSectionTeacher = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_TEACHER_ASSIGNED_CLASS_SECTION_LIST_APIURL}?SchoolID=${schoolID}`, {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const InsertClassTeacher = async (payload) => {
  return commonFetch(API_URLS.ADD_CLASSTEACHER_ASSINED_CLASS_SECTION_APIURL, {
    method: 'POST',
    body: payload,
    headers: {

    },
    requiresAuth: true,
  });
};

export const updateClassTeacher = async (payload) => {
  return commonFetch(API_URLS.UPDATE_CLASSTEACHER_ASSINED_CLASS_SECTION_APIURL, {
    method: "POST",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true,
  });
};

export const deleteClassTeacherById = async (id) => {
  if (!id) throw new Error("Invalid ID for delete");

  return commonFetch(
    `${API_URLS.DELETE_TEACHER_ASSIGNED_CLASS_SECTION_APIURL}/Id?ID=${id}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      requiresAuth: true,
    });
};

export const addFeeType = async (payload) => {
  return commonFetch(API_URLS.ADD_FEETYPE_APIURL, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

export const deleteFeeType = async (id) => {
  return commonFetch(`${API_URLS.DELETE_FEETYPE_APIURL}/${id}`, {
    method: 'DELETE',
    requiresAuth: true,
  });
};

export const getAllFeeType = async (SchoolID) => {
  return commonFetch(`${API_URLS.GETALL_FEETYPE_APIURL}?schoolId=${SchoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const updateFeeType = async (id, payload) => {
  return commonFetch(`${API_URLS.UPDATE_FEETYPE_APIURL}/${id}`, {
    method: 'PUT',
    body: payload,
    requiresAuth: true,
  });
};

export const addFeeFrequency = async (payload) => {
  return commonFetch(API_URLS.ADD_FEEFREQUENCY_APIURL, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const deleteFeeFrequency = async (id) => {
  return commonFetch(`${API_URLS.DELETE_FEEFREQUENCY_APIURL}/${id}`, {
    method: "DELETE",
    requiresAuth: true,
  });
};

export const getAllFeeFrequency = async (SchoolID) => {
  return commonFetch(`${API_URLS.GETALL_FEEFREQUENCY_APIURL}?schoolId=${SchoolID}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const updateFeeFrequency = async (id, payload) => {
  return commonFetch(`${API_URLS.UPDATE_FEEFREQUENCY_APIURL}/${id}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};



export const getFeetypeList = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ALL_FEE_TYPE_APIURL}?schoolId=${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};
export const getFeeFrequencyList = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ALL_FEE_FREQUENCY_APIURL}?schoolId=${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};



export const SubmitFeeStrutureAssignToClass = async (formData) => {
  return commonFetch(`${API_URLS.ADD_FEE_STRUCTURE_TO_CLASS_APIURL}`, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};

export const UpdateFeeStrutureAssignToClass = async (classID, formData) => {
  return commonFetch(`${API_URLS.UPDATE_FEE_STRUCTURE_TO_CLASS_APIURL}/${classID}`, {
    method: "PUT",
    body: formData,
    requiresAuth: true
  });
};


export const DeleteFeeStrutureAssignToClass = async (schoolID, classID, payload) => {
  return commonFetch(`${API_URLS.DELETE_FEE_STRUCTURE_TO_CLASS_APIURL}/${schoolID}/${classID}`, {
    method: "DELETE",
    body: payload,
    requiresAuth: true,
  });
};

export const NoticeGetAllRoles = async () => {
  return commonFetch(API_URLS.NOTICE_GET_ALL_ROLES, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getAllRoles = async () => {
  return commonFetch(API_URLS.GET_ALL_ROLES, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getAllMenuList = async () => {
  return commonFetch(API_URLS.GET_ALL_MENU_LIST, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getInsertAndUpdateRoleRoute = async (payload) => {
  return commonFetch(API_URLS.GET_INSERT_AND_UPDATE_ROLE_ROUTE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};



export const getRouteDetailByRoleId = async (roleId, schoolId) => {
  return commonFetch(`${API_URLS.GET_ROUTE_DETAIL_BY_ROLE_ID}?RoleId=${roleId}&SchoolID=${schoolId}`, {
    method: "GET",
    requiresAuth: true,
  });
};



export const AdminGetAllRoles = async (schoolID) => {
  const url = `${API_URLS.ADMIN_GET_ALL_ROLES}?schoolId=${schoolID}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};


export const CommunicationMessageAllSent = async (schoolID) => {
  const url = `${API_URLS.COMMUNICATION_MESSAGE_ALL_SENT}?schoolId=${schoolID}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};


export const AdminCommunicationMessage = async (payload) => {
  if (!payload.schoolID) {
    throw new Error("schoolID is required in the payload");
  }
  const url = `${API_URLS.ADMIN_COMMUNICATION_MESSAGE}?schoolId=${payload.schoolID}`;
  return commonFetch(url, {
    method: "POST",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true,
  });
};


export const AddNoticeByRole = async (payload) => {
  return commonFetch(API_URLS.ADD_NOTICE_BY_ROLE, {
    method: "POST",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true,
  });
};

export const UpdateNoticeByRole = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_NOTICE_BY_ROLE}/?schoolId=${payload.schoolId}`, {
    method: "PUT",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true
  });
};

export const DeleteNoticeBoard = async (payload) => {
  const url = `${API_URLS.DELETE_NOTICE_BY_ROLE}`
  return commonFetch(url, {
    method: "DELETE",
    requiresAuth: true,
    body: payload
  }
  );
};

export const RoleNoticeDetailsByNoticeId = async (schoolID) => {
  const url = `${API_URLS.ROLE_NOTIFICATION_BY_NOTICEID}?schoolId=${schoolID}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const AllNoticeList = async (schoolID) => {
  const url = `${API_URLS.ALL_NOTICE_LIST}?schoolId=${schoolID}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const GetNoticeCategorylist = async (schoolID) => {
  const url = `${API_URLS.GET_NOTICE_CATEGORY_LIST}`;
  // const url = `${API_URLS.GET_NOTICE_CATEGORY_LIST}?schoolId=${schoolID}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};
// 
// export const getAllFeesCollectionList = async (schoolId) => {
//   return commonFetch(`${API_URLS.GETALL_FEECOLLECTION_APIURL}?schoolId=${schoolId}`, {
//     method: "POST",
//     requiresAuth: true
//   });
// };

export const SidebarConfigurationGetAllLabel = async (schoolID, payload) => {
  return commonFetch(`${API_URLS.SIDEBAR_CONFIGURATION_GET_ALL_LABEL}/${schoolID}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const SidebarConfigurationInsertOrUpdate = async (schoolID, payload) => {
  return commonFetch(`${API_URLS.SIDEBAR_CONFIGURATION_INSERT_OR_UPDATE}/${schoolID}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};



export const getAllFeesCollectionList = async (schoolId, body = {}) => {
  return commonFetch(
    `${API_URLS.GETALL_FEECOLLECTION_APIURL}/${schoolId}`,
    {
      method: "POST",
      body: body,
      headers: {
        "Content-Type": "application/json"
      },
      requiresAuth: true
    }
  );
};

export const UpdateAllFeesCollection = async (payload) => {
  if (!payload.schoolID) {
    throw new Error("schoolID is required in the payload");
  }

  const url = `${API_URLS.UPDATE_ALL_FEE_COLLECTION_APIURL}/${payload.schoolID}`;

  return commonFetch(url, {
    method: "POST",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true,
  });
};


export const getFeesCollectionList = async (schoolId, body = {}) => {
  return commonFetch(
    `${API_URLS.GET_ALL_FEE_COLLECTION_APIURL}/${schoolId}`,
    {
      method: "POST",
      body: body,
      headers: {
        "Content-Type": "application/json"
      },
      requiresAuth: true
    }
  );
};



export const getAllColletionStatusList = async (payload) => {
  return commonFetch(API_URLS.GET_ALL_COLLECTION_STATUS_LIST,
    {
      method: "POST",
      requiresAuth: true,
      body: payload,
    }
  );
};

export const getAllFeesColletionCheckStatusList = async (schoolId, studentId) => {
  return commonFetch(
    `${API_URLS.GET_ALL_FEES_VIEW_COLLECTION_CHECK_STATUS_LIST}?schoolId=${schoolId}&studentId=${studentId}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


export const getAllFeeDetailsByStudentID = async (schoolId, studentId) => {
  return commonFetch(
    `${API_URLS.GET_ALL_STUDENT_FEE_DETAILS_LIST}?StudentID=${studentId}&SchoolID=${schoolId}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


export const getInvoiceByFeeCollectId = async (schoolId, feeCollectId) => {
  return commonFetch(
    `${API_URLS.GET_INVOICE_BY_FEE_COLLECT_ID}/${schoolId}/${feeCollectId}`,
    {
      method: "POST",
      requiresAuth: true,
    }
  );
};

// export const StudentSubjectList = async ({ schoolID, studentID, classID }) => {
//   const url = `${API_URLS.STUDENT_SUBJECT_LIST}?schoolId=${schoolID}&studentId=${studentID}&classId=${classID}`;
//   return commonFetch(url, {
//     method: "GET",
//     requiresAuth: true,
//   });
// };


export const GetAllCalenderData = async (payload) => {
  return commonFetch(API_URLS.GET_ALL_CALENDER_DATA, {
    method: "POST",
    body: payload,
    requiresAuth: true
  });
};

export const GetAllSideBarUpdatedMenu = async (schoolID, payload) => {
  if (!schoolID) {
    throw new Error("schoolID is required to fetch sidebar menu");
  }
  return commonFetch(`${API_URLS.SIDEBAR_UPDATEDMENU}/${schoolID}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getLogoBase64Post = async (payload) => {
 return commonFetch(`${API_URLS.GET_LOGO_BASE64POST}`, {
    method: "POST",  
     body:payload,
    requiresAuth: true,
  });
};

export const GetCreateticket = async (payload) => {
 return commonFetch(`${API_URLS.CREATE_TICKET_SUPPORT}`, {
    method: "POST",  
     body:payload,
    requiresAuth: true,
  });
};

export const getAllTickets = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_TICKETS_SUPPORT}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getStaffDetails = async (schoolID, employeeID) => {
  return commonFetch(
    `${API_URLS.GET_STAFF_DETAILS}/${schoolID}/${employeeID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


export const GetChangePassword = async (payload) => {
 return commonFetch(`${API_URLS.GET_EMPLOYEE_CHANGE_PASSWORD}`, {
    method: "POST",  
     body:payload,
    requiresAuth: true,
  });
};

export const createExam = async (payload) => {
  return commonFetch(`${API_URLS.CREATE_EXAM}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getExamList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_EXAM_LIST}/${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const updateExam = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_EXAM}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const deleteExamDetails = async (payload) => {
  return commonFetch(`${API_URLS.DELETE_EXAM_DETAILS}`, {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

export const createHoliday = async (payload) => {
  return commonFetch(`${API_URLS. CREATE_HOLIDAY}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};


export const updateHoliday = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_HOLIDAY}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const getAllLeaveMasterTypes = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_LEAVE_MASTER_TYPES}/${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const addLeaveMasterType = async (payload) => {
  return commonFetch(API_URLS.ADD_LEAVE_MASTER_TYPES, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};

export const updateLeaveMasterTypes = async (payload) => {
  return commonFetch(API_URLS.UPDATE_LEAVE_MASTER_TYPES, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const deleteLeaveMasterTypes = async (leaveTypeID , formData) => {
  return commonFetch(`${API_URLS.DELETE_LEAVE_MASTER_TYPES}/${leaveTypeID}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};

export const getStaffLeaveByEmployee = async (schoolID,employeeID) => {
  return commonFetch(
    `${API_URLS.GET_STAFF_LEAVE_BY_EMPLOYEE}/${employeeID}?schoolid=${schoolID}`,
    
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const AddStaffLeave = async (payload) => {
  return commonFetch(API_URLS.ADD_STAFF_LEAVE, {
    method: 'POST',
    body: payload,
 
    requiresAuth: true,
  });
};

export const updateStaffLeave = async (payload) => {
  return commonFetch(API_URLS.UPDATE_STAFF_LEAVE, {
    method: 'PUT',

    body: payload,
    requiresAuth: true,
  });
};

export const deleteStaffLeave = async (payload) => {
  return commonFetch(API_URLS.DELETE_STAFF_LEAVE, {
    method: 'DELETE',
    body: payload,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};

export const getAllEmpolyeeLeaveData = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_EMPLOYEE_LEAVE_DATA}/${schoolID}`,
    
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const getAllStudentLeaveData = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_STUDENT_LEAVE_DATA}?schoolId=${schoolID}`,
    
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const UpdateLeaveRequestByAdmin = async (payload) => {
  return commonFetch(API_URLS.APPROVE_LEAVE_REQUEST_BY_ADMIN, {
    method: 'POST',
    body: payload,
 
    requiresAuth: true,
  });
};


export const DeleteStudentEmployeeLeave = async (payload) => {
  return commonFetch(API_URLS.DELETE_STUDENT_EMPLOYEE_LEAVE, {
    method: 'DELETE',
    body: payload,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};

export const getStudentLeaveData = async (schoolID, studentID) => {
  return commonFetch(`${API_URLS.GET_STUDENT_LEAVE_DATA}?schoolId=${schoolID}&studentId=${studentID}`, {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const AddStudentLeave = async (payload) => {
  return commonFetch(API_URLS.STUDENT_APPLY_LEAVE, {
    method: 'POST',
    body: payload,
 
    requiresAuth: true,
  });
};

export const updateStudentLeave = async (payload) => {
  return commonFetch(API_URLS.UPDATE_LEAVE_BY_STUDENT, {
    method: 'PUT',
    body: payload,
    requiresAuth: true,
  });
};

export const deleteStudentLeave = async (payload) => {
  return commonFetch(API_URLS.DELETE_LEAVE_BY_STUDENT, {
    method: 'DELETE',
    body: payload,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};


export const ApproveLeaveRequestByTeacher = async (payload) => {
  return commonFetch(API_URLS.APPROVE_LEAVE_REQUEST_BY_TEACHER, {
    method: 'POST',
    body: payload,
 
    requiresAuth: true,
  });
};


export const DeleteStudentLeave = async (payload) => {
  return commonFetch(API_URLS.DELETE_STUDENT_LEAVE, {
    method: 'DELETE',
    body: payload,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};
export const getAllEmployeeAttendaceList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_EMPLOYEE_ATTENDANCE_LIST}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const markEmployeeAttendance = async (payload) => {
  return commonFetch(`${API_URLS.MARK_EMPLOYEE_ATTENDANCE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const updateEmployeeAttendance = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_EMPLOYEE_ATTENDANCE}/`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const staffPunchInPunchOut = async (payload) => {
  return commonFetch(`${API_URLS.STAFF_PUNCHIN_PUNCHOUT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  }); 
};

export const getEmployeeAttendaceReportList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_EMPLOYEE_ATTENDANCE_REPORT_LIST}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const createExamSchedule = async (payload) => {
  return commonFetch(`${API_URLS.CREATE_EXAM_SCHEDULE}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: payload,
    requiresAuth: true,
  });
};

export const getExamScheduleByClass = async (payload) => {
  
  return commonFetch(`${API_URLS.GET_EXAM_SCHEDULE_BY_CLASS}`,{
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};


export const updateExamSchedule = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_EXAM_SCHEDULE}/?schoolId=${payload.schoolId}`, {
    method: "PUT",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true
  });
};

export const deleteExamScheduleDetail = async (payload) => {
  const url = `${API_URLS.DELETE_EXAM_SCHEDULE_DETAIL}`
  return commonFetch(url, {
    method: "DELETE",
    requiresAuth: true,
    body: payload
  });
};

export const getAllHolidays = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GETALL_HOLIDAY}?schoolId=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const DeleteHolidays = async (payload) => {
  return commonFetch(API_URLS.DELETE_HOLIDAY, {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

export const addUpdateExamMarks = async (payload) => {
  return commonFetch(`${API_URLS.ADD_UPDATE_EXAM_MARKS}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getExamMarksByClass = async (payload) => {
  return commonFetch(
    `${API_URLS.GET_EXAM_MARKS_BY_CLASS}`,
    {
      method: "Post",
      body: payload,
      requiresAuth: true,
    }
  );
};

export const GetExamReportResultdata = async (payload) => {
  return commonFetch(`${API_URLS.GET_EXAM_RESULT_REPORT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  
  });
};


export const GetStudentHomeworkDashboardData = async (studentID, classId, sectionID) => {
  const params = new URLSearchParams();

  if (studentID) params.append("StudentID", studentID);
  if (classId) params.append("ClassID", classId);
  if (sectionID) params.append("SectionID", sectionID);

  return commonFetch(
    `${API_URLS.GET_STUDENT_HOMEWORKDASHBOARD_DATA}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
 
    }
  );
};

export const getEmployeeAttendanceList = async (schoolID,employeeID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_EMPLOYEE_ATTENDANCE_LIST}?SchoolID=${schoolID}&EmployeeID=${employeeID}`,
    
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const GetStudentTimetable = async (studentID, classId, sectionID,schoolID) => {
  const params = new URLSearchParams();

  if (studentID) params.append("studentID", studentID);
  if (classId) params.append("classId", classId);
  if (sectionID) params.append("sectionID", sectionID);
  if (schoolID) params.append("schoolID", schoolID);

  return commonFetch(`${API_URLS.GET_TIMETABLE_STUDENTDASHBOARD}?${params.toString()}`, {
    method: "GET",
    requiresAuth: true,
  
  });
};
// export const GetStudentTimetable = async (studentID, classId, sectionID,schoolID) => {
//   return commonFetch(
//     `${API_URLS.GET_TIMETABLE_STUDENTDASHBOARD}?StudentID=${studentID}&ClassID=${classId}&SectionID=${sectionID}&schoolID=${schoolID}`,
//     {
//       method: "GET",
//       requiresAuth: true,
//     }
//   );
// };

export const getTodayClasses = async (employeeID,schoolID) => {
  return commonFetch(
    `${API_URLS.GET_TODAY_CLASSES_FOR_TEACHER}?TeacherID=${employeeID}&SchoolID=${schoolID}`,
    
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


export const getBirthdayReminder = async (employeeID,schoolID) => {
  return commonFetch(
    `${API_URLS.GET_BIRTHDAY_REMINDER_FOR_TEACHER}?TeacherID=${employeeID}&SchoolID=${schoolID}`,
    
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const examStatusUpdate = async (payload) => {
  return commonFetch(`${API_URLS.EXAM_STATUS_UPDATE}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};


export const GetAllBusRouteList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_BUS_ROUTE_LIST}?SchoolID=${schoolID}`,
    
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const InsertBusRoute = async (formdata) => {
  return commonFetch(`${API_URLS.INSERT_BUS_ROUTE}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const UpdateBusRoute = async (formdata) => {
  return commonFetch(`${API_URLS.UPDATE_BUS_ROUTE}`, {
    method: "PUT",
    body: formdata,
    requiresAuth: true,
  });
};

export const DeleteBusRoute = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_BUS_ROUTE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};

export const UpdateBusRouteStatus = async (formdata) => {
  return commonFetch(`${API_URLS.UPDATE_ROUTE_STATUS}`, {
    method: "PUT",
    body: formdata,
    requiresAuth: true,
  });
};

export const getAllBusRouteList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_BUS_ROUTE_LIST}?SchoolID=${schoolID}`,  
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getAllDriverList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_DRIVER_LIST}?SchoolID=${schoolID}`,  
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getAllHelperList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_HELPER_LIST}?SchoolID=${schoolID}`,  
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const insertVehicleDetails = async (payload) => {
  return commonFetch(`${API_URLS.INSERT_VEHICLE_DETAILS}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  
  });
};

export const updateVehicleDetails = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_VEHICLE_DETAILS}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const getAllVechileList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_VECHICLE_LIST}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const deleteVechileList = async (payload) => {
  return commonFetch(API_URLS.DELETE_VECHICLE_LIST, {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

export const vechileStatusUpdate = async (payload) => {
  return commonFetch(`${API_URLS.STATUS_TOGGLE_VECHICLE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};


//Gate Pass Master Service
export const ExitGateMasterPost = async (payload) => {
  return commonFetch(`${API_URLS.EXIT_GATE_MASTER_POST}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getAllGatePass = async (schoolID) => {
  return commonFetch(
    `${API_URLS.EXIT_GATE_MASTER_GET}?SchoolID=${schoolID}&PageNumber=${1}&PageSize=${50}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const updateGatePass = async (gateID,payload) => {
  return commonFetch(`${API_URLS.EXIT_GATE_MASTER_PUT}${gateID}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const deleteGetPass = async (gateID,schoolID) => {
  return commonFetch(`${API_URLS.EXIT_GATE_MASTER_DELETE}${gateID}?SchoolID=${schoolID}`, {
    method: 'DELETE',
    requiresAuth: true,
  });
};


//Visit Purpose Service

export const AddVisitPurpose = async (payload) => {
  return commonFetch(`${API_URLS.ADD_VISIT_PURPOSE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getAllPurpose = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_VISIT_PURPOSE}?SchoolID=${schoolID}&PageNumber=${1}&PageSize=${50}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const updateVisitPurpose = async (purposeID,payload) => {
  return commonFetch(`${API_URLS.UPDATE_VISIT_PURPOSE}${purposeID}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const deleteVisitPurpose = async (purposeID,schoolID) => {
  return commonFetch(`${API_URLS.DELETE_VISIT_PURPOSE}${purposeID}?SchoolID=${schoolID}`, {
    method: 'DELETE',
    requiresAuth: true,
  });
}

export const createSchool = async (formData) => {
  return commonFetch(API_URLS.CREATE_SCHOOL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};


export const getAllSchools = async (PageNumber,PageSize) => {
  return commonFetch(
    `${API_URLS.GET_ALL_SCHOOLS}?PageNumber=${PageNumber}&PageSize=${PageSize}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getAllAdmins = async (PageNumber,PageSize) => {
  return commonFetch(
    `${API_URLS.GET_ALL_Admins}?PageNumber=${PageNumber}&PageSize=${PageSize}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const createAdminForSchool = async (formData) => {
  return commonFetch(API_URLS.CREATE_ADMIN_FOR_SCHOOL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};
export const createDirectorForSchool = async (formData) => {
  return commonFetch(API_URLS.CREATE_DIRECTOR_FOR_SCHOOL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};
export const createSuperDirectorForSchool = async (formData) => {
  return commonFetch(API_URLS.CREATE_SUPER_DIRECTOR_FOR_SCHOOL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const searchDirector = async (searchValue) => {
  return commonFetch(
    `${API_URLS.SEARCH_DIRECTOR_FOR_SCHOOL}?SearchValue=${searchValue}`,
    {
      method: "POST",
      requiresAuth: true,
    }
  );
};

export const TicketTrackingActions = async (payload) => {
  return commonFetch(`${API_URLS.TICKETS_TRACKING_ACTIONS}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetAllSchoolList = async () => {
  return commonFetch(API_URLS.GET_SCHOOL_LIST, {
    method: "GET",
    requiresAuth: true,
  });
};

//Group List

export const  PostGroup = async (payload) => {
  return commonFetch(`${API_URLS.POST_GROUP_LIST}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetAllGroup = async (groupId) => {
  return commonFetch( `${API_URLS.GET_ALL_GROUPS}?groupId=${groupId}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const GetAllSchool = async () => {
  return commonFetch( `${API_URLS.GETALL_SCHOOLlIST}`, {
    method: "GET",
    requiresAuth: true,
  });
};


export const  SetAdminsForSchool = async (payload) => {
  return commonFetch(`${API_URLS.SET_ADMINS_SCHOOLACCESS}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetAllAdminsSchool = async (adminID) => {
  return commonFetch( `${API_URLS.GET_ADMINS_SCHOOL}${adminID}`, {
    method: "GET",
    requiresAuth: true,
  });
};
export const GetAllSchoolOnboardingData = async (adminID) => {
  return commonFetch( `${API_URLS.GET_ALL_SCHOOLS_ONBOARDING_DATA}${adminID}`, {
    method: "GET",
    requiresAuth: true,
  });
};